<mat-card
  id="uploadFileContainer"
  class="upload-file-container"
  (click)="fileInput.click()"
  madDragAndDrop
  (onFileDropped)="uploadFile($event)"
>
  <input
    #fileInput
    hidden
    type="file"
    [id]="id()"
    [multiple]="multiple()"
    [accept]="acceptAttribute()"
    (change)="uploadFile(fileInput.files)"
    (click)="fileInput.value = ''"
  />
  <mat-card-content class="upload-file-content">
    @if (hasSingleFile()) {
      {{ fileList()[0].name }}
    } @else {
      <mat-icon>vertical_align_top</mat-icon>
      {{ uploadLabel() }}
    }
  </mat-card-content>
</mat-card>

@if (showFileList()) {
  <mat-chip-listbox>
    @for (file of fileList(); track file) {
      <mat-chip class="download" (click)="openFile(file)" [removable]="removable()" (removed)="remove(file)">
        {{ file.name }}
        @if (removable()) {
          <mat-icon matChipRemove>delete_forever</mat-icon>
        }
      </mat-chip>
    }
  </mat-chip-listbox>
}
